export const ORCHS_REQUEST = 'ORCHS_REQUEST';
export const ORCHS_SUCCESS = 'ORCHS_SUCCESS';
export const ORCHS_FAILURE = 'ORCHS_FAILURE';

export const USER_COUNTS_REQUEST = 'USER_COUNTS_REQUEST';
export const USER_COUNTS_SUCCESS = 'USER_COUNTS_SUCCESS';
export const USER_COUNTS_FAILURE = 'USER_COUNTS_FAILURE';

export const ORCH_VERSIONS_REQUEST = 'ORCH_VERSIONS_REQUEST';
export const ORCH_VERSIONS_SUCCESS = 'ORCH_VERSIONS_SUCCESS';
export const ORCH_VERSIONS_FAILURE = 'ORCH_VERSIONS_FAILURE';

export const ORCH_VERSION_REQUEST = 'ORCH_VERSION_REQUEST';
export const ORCH_VERSION_SUCCESS = 'ORCH_VERSION_SUCCESS';
export const ORCH_VERSION_FAILURE = 'ORCH_VERSION_FAILURE';

export const ORCH_VER_CREATIVES_REQUEST = 'ORCH_VER_CREATIVES_REQUEST';
export const ORCH_VER_CREATIVES_SUCCESS = 'ORCH_VER_CREATIVES_SUCCESS';
export const ORCH_VER_CREATIVES_FAILURE = 'ORCH_VER_CREATIVES_FAILURE';

export const CREATE_ORCH_REQUEST = 'CREATE_ORCH_REQUEST';
export const CREATE_ORCH_SUCCESS = 'CREATE_ORCH_SUCCESS';
export const CREATE_ORCH_FAILURE = 'CREATE_ORCH_FAILURE';

export const CREATE_ORCH_VER_REQUEST = 'CREATE_ORCH_VER_REQUEST';
export const CREATE_ORCH_VER_SUCCESS = 'CREATE_ORCH_VER_SUCCESS';
export const CREATE_ORCH_VER_FAILURE = 'CREATE_ORCH_VER_FAILURE';

export const CREATE_ORCH_VER_CREATIVE_REQUEST =
  'CREATE_ORCH_VER_CREATIVE_REQUEST';
export const CREATE_ORCH_VER_CREATIVE_SUCCESS =
  'CREATE_ORCH_VER_CREATIVE_SUCCESS';
export const CREATE_ORCH_VER_CREATIVE_FAILURE =
  'CREATE_ORCH_VER_CREATIVE_FAILURE';

export const DELETE_ORCH_REQUEST = 'DELETE_ORCH_REQUEST';
export const DELETE_ORCH_SUCCESS = 'DELETE_ORCH_SUCCESS';
export const DELETE_ORCH_FAILURE = 'DELETE_ORCH_FAILURE';

export const UPDATE_ORCH_REQUEST = 'UPDATE_ORCH_REQUEST';
export const UPDATE_ORCH_SUCCESS = 'UPDATE_ORCH_SUCCESS';
export const UPDATE_ORCH_FAILURE = 'UPDATE_ORCH_FAILURE';

export const UPDATE_ORCH_VER_REQUEST = 'UPDATE_ORCH_VER_REQUEST';
export const UPDATE_ORCH_VER_SUCCESS = 'UPDATE_ORCH_VER_SUCCESS';
export const UPDATE_ORCH_VER_FAILURE = 'UPDATE_ORCH_VER_FAILURE';

export const UPDATE_ORCH_VER_STATE_REQUEST = 'UPDATE_ORCH_VER_STATE_REQUEST';
export const UPDATE_ORCH_VER_STATE_SUCCESS = 'UPDATE_ORCH_VER_STATE_SUCCESS';
export const UPDATE_ORCH_VER_STATE_FAILURE = 'UPDATE_ORCH_VER_STATE_FAILURE';

export const ADD_ORCH_VER_NODE = 'ADD_ORCH_VER_NODE';
export const SET_CURRENT_ORCH = 'SET_CURRENT_ORCH';
export const SET_CURRENT_ORCH_VER = 'SET_CURRENT_ORCH_VER';

export const HIDE_ERRORS = 'HIDE_ERRORS';

export const DELETE_ORCH_VER_NODE = 'DELETE_ORCH_VER_NODE';
export const DELETE_ORCH_VER_ALL_EXCEPT_BRANCH =
  'DELETE_ORCH_VER_ALL_EXCEPT_BRANCH';
export const DELETE_ORCH_VER_ALL_CHILDREN = 'DELETE_ORCH_VER_ALL_CHILDREN';
export const CREATE_NEW_ORCH_DRAFT = 'CREATE_NEW_ORCH_DRAFT';

export const UPDATE_ORCH_NAME_REQUEST = 'UPDATE_ORCH_NAME_REQUEST';
export const UPDATE_ORCH_NAME_SUCCESS = 'UPDATE_ORCH_NAME_SUCCESS';
export const UPDATE_ORCH_NAME_FAILURE = 'UPDATE_ORCH_NAME_FAILURE';

export const UPDATE_ORCH_EVENT_REQUEST = 'UPDATE_ORCH_EVENT_REQUEST';
export const UPDATE_ORCH_EVENT_SUCCESS = 'UPDATE_ORCH_EVENT_SUCCESS';
export const UPDATE_ORCH_EVENT_FAILURE = 'UPDATE_ORCH_EVENT_FAILURE';

export const UPDATE_ORCH_LIMIT_REQUEST = 'UPDATE_ORCH_LIMIT_REQUEST';
export const UPDATE_ORCH_LIMIT_SUCCESS = 'UPDATE_ORCH_LIMIT_SUCCESS';
export const UPDATE_ORCH_LIMIT_FAILURE = 'UPDATE_ORCH_LIMIT_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/ApiActionTypes.js